export default {"src":"/_next/static/media/chevron_left.46efc342.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};